// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';


// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

// import * as ServiceIcons from '../service/Icons';

import * as coreSelectors from '../core/selectors';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
// import Badge from '@material-ui/core/Badge';
// import PhoneIcon from '@material-ui/icons/Phone';
// import DateRangeIcon from '@material-ui/icons/DateRange';

const styles = theme => ({
  topLayout : {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 1,
    width: '100%',
    height: '100%',
  },
  titleBar : {
    display: 'flex',
    alignItems: 'center',
  },
  title : {
    ...theme.typography.h6,
    fontWeight: 'bold',
    paddingLeft: 20,
    paddingRight: 20,
  },
  accountScroll : {
    padding: 10,
    //overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flexGrow: 1,
    flexBasis: 1,
  },
  accountList : {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexGrow: 1,
  },
  accountName : {
    ...theme.typography.body2,
  },
  accountItem : {
    display: 'flex',
    flexDirection: 'column',
  },
  MuiLinearProgressBarColorPrimary: {
    backgroundColor: 'white'
  },
  progressBar : {
    height: 30,
    borderRadius: 15,
    backgroundColor:'white',
    // boxShadow: theme.shadows[3],
  },
  progressBar75 : {
    height: 30,
    borderRadius: 15,
    background:'yellow',
    // boxShadow: theme.shadows[3],
  },
  progressBar90 : {
    height: 30,
    borderRadius: 15,
    background:'orange',
    // boxShadow: theme.shadows[3],
  },
  progressBar100 : {
    height: 30,
    borderRadius: 15,
    background:'red',
    // boxShadow: theme.shadows[3],
  },
  accountItemText : {
    marginTop: 10,
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:last-child' : {
      marginBottom: 0,
    },
  },
  used : {
    display:'flex',
    alignItems:'center',
    ...theme.typography.body1,
    fontFamily:'Sofia',
    fontSize:15
  },
  remaining : {
    ...theme.typography.body1,
    fontWeight: 'bold',
  },
  noUsage : {
    ...theme.typography.body1,
    fontStyle: 'italic',
  },
  accountItemCalls:{
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  typographyStyle:{
    fontFamily:'Sofia',
    fontWeight:'700',
    fontSize: 18
  }
});

/*
 * Display a progress bar of minutes used for each account the user has admin access
 */

class MinutesUsed extends Component {

  state = {
  }

  colorForUsage = (used,plan) => {
    var percUsage = Math.round((used*100)/plan);
    if( percUsage>=75 && percUsage< 90){
      return "progressBar75";
    }
    else if( percUsage>=90 && percUsage< 100){
      return "progressBar90";
    }else if(percUsage>=100){
      return "progressBar100";
    }
    return "noColor";
  }

  getUiForUsage = (role, classes, value) => {
    return(
      <div key={role.accountId} className={classes.accountItem}>
          <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 22, marginTop: 15}}>{role.accountName}</MuiCore.Typography>
          <div className={classes.accountItemText}>
              <MuiCore.Typography>
                <span style={{fontFamily: 'Sofia-bold', fontSize: 36}}>
                  {role.usedMinutes !== undefined ? role.usedMinutes : 0}
                </span>
                {role.planMinutes !== undefined && <span style={{fontFamily: 'Sofia-bold', fontSize: 20}}>
                  / {role.planMinutes !== undefined ? role.planMinutes : 0}
                </span>}
                <span style={{fontFamily: 'Sofia-bold', fontSize: 14, color: '#858DA3'}}>
                  &nbsp; &nbsp;Minutes used
                </span>
              </MuiCore.Typography>
          </div>
          <MuiCore.LinearProgress className={classes.progressBar} color='secondary' style={{height: 30}}
                                  value={value} variant='determinate'/>
          <div className={classes.accountItemCalls}>
          </div> 
          <MuiCore.Grid container  justifyContent="space-between" style={{marginTop: 20}}>
            <MuiCore.Grid item xs={3} style={{backgroundColor:'rgba(0,0,0, 0.03)', height: 70, margin: 5}} justifyContent='center'>
              <MuiCore.Typography className={classes.textBold} style={{fontFamily: 'Sofia-bold', fontSize: 24, textAlign: 'center'}}>{role.totalCalls}</MuiCore.Typography>
              <MuiCore.Typography className={classes.textLight} style={{fontFamily: 'Sofia', fontSize: 12, textAlign: 'center'}}>total calls</MuiCore.Typography>
            </MuiCore.Grid>
            {role.chatServiceEnabled === 'Y' && <MuiCore.Grid item xs={3} style={{backgroundColor:'rgba(0,0,0, 0.03)', height: 70, margin: 5}} justifyContent='center'>
              <MuiCore.Typography className={classes.textBold} style={{fontFamily: 'Sofia-bold', fontSize: 24, textAlign: 'center'}}>{role.totalChats}</MuiCore.Typography>
              <MuiCore.Typography className={classes.textLight} style={{fontFamily: 'Sofia', fontSize: 12, textAlign: 'center'}}>total chats</MuiCore.Typography>
            </MuiCore.Grid>}
            <MuiCore.Grid item xs={3} style={{backgroundColor:'rgba(0,0,0, 0.03)', height: 70, margin: 5}}>
              <MuiCore.Typography className={classes.textBold} style={{fontFamily: 'Sofia-bold', fontSize: 24, textAlign: 'center'}}>{role.daysLeft}</MuiCore.Typography>
              <MuiCore.Typography className={classes.textLight} style={{fontFamily: 'Sofia', fontSize: 12, textAlign: 'center'}}>days left in cycle</MuiCore.Typography>
            </MuiCore.Grid>
          </MuiCore.Grid>
        </div>
    )
  }

  checkParentAccount = () => {
    return this.props.user.userAccountRoles.filter(account => account.parentAccountId !== undefined).length > 0;
  }

  
  render() {
    // eslint-disable-next-line
    const { classes, user} = this.props;

    let count = (user.userAccountRoles || []).filter(role => role.userRoleKey === 'GLOBALADMIN').length;
    var distinctAccounts = []
    var accounts = (this.props.user.userAccountRoles || [])
    .filter((role,index,arr) => {

      if(role.userRoleKey === 'GLOBALADMIN' && distinctAccounts.indexOf(role.accountId) === -1){
        distinctAccounts.push(role.accountId)
        return true;
      }else{
        return false;
      }
    });

    return(
      <div className={classes.topLayout} >
        <MuiCore.Accordion style={{backgroundColor: 'transparent', border: 'none', zIndex: 0}}>
          <MuiCore.AccordionSummary
            expandIcon={<AddCircleOutlineIcon />}
          >
             <div className={classes.titleBar}>
                {/* <ServiceIcons.IncomingCallIcon/> */}
                <div className={classes.title}>
                <MuiCore.Typography className={classes.typographyStyle}>
                    Current Usage
                </MuiCore.Typography> 
                </div>
              </div>
          </MuiCore.AccordionSummary>

          <MuiCore.AccordionDetails>
        <div className={classes.accountScroll}>

        <div className={classes.accountList}>
          {this.props.user.userAccountRoles?.filter(account => account.showCombinedUsage === 'Y').map(parentAccount => (
            this.getUiForUsage({
              accountName: "Combined Usage - " + parentAccount.accountName,
              accountId: parentAccount.accountId,
              usedMinutes: parentAccount.combinedTotalMin,
              totalCalls: parentAccount.combinedTotalCalls,
              totalChats: parentAccount.totalCombinedChats,
              chatServiceEnabled: parentAccount.chatServiceEnabled,
              daysLeft: parentAccount.daysLeft
            }, classes, 100)
          ))}
          {accounts.map(role => {
            let value = role.planMinutes ? ((role.usedMinutes / role.planMinutes) * 100) : 100;
            if (value > 100) {
              value = 100;
            }
            let remaining = role.planMinutes - role.usedMinutes;
            if (remaining < 0) {
              remaining = 0;
            }
            return this.getUiForUsage(role, classes, value);
          })}
          <MuiCore.Hidden xlDown={count > 0}>
            <div className={classes.noUsage}>
              No usage available 
            </div>
          </MuiCore.Hidden>
        </div>

        </div>
        </MuiCore.AccordionDetails>
        </MuiCore.Accordion>
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
  });
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MinutesUsed));

